import { environment } from '@environment';

function getUploadsStorageFolder() {
    if (environment.uploadsStorageFolder) {
        return environment.uploadsStorageFolder;
    }

    return environment.name === 'production' ? 'live' : 'qa';
}

function appendQuery(url: string, query: string) {
    if (!query) {
        return url;
    }

    return `${url}${query.startsWith('?') ? query : `?${query}`}`;
}

export function getUserAvatarUrl(userId?: number | null, cacheKey?: number | string) {
    if (!userId) {
        return '';
    }

    const folder = getUploadsStorageFolder();
    const baseUrl = `${environment.azureNetraMediaUrl}/${environment.azureContainerName}/${folder}/users/${userId}/avatar`;
    const urlWithSas = appendQuery(baseUrl, environment.fileStorageSas ?? '');

    if (!cacheKey) {
        return urlWithSas;
    }

    return `${urlWithSas}${urlWithSas.includes('?') ? '&' : '?'}v=${encodeURIComponent(`${cacheKey}`)}`;
}
